(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["left-image-with-text"] && !window.DesignMode) return;
  try {
    
  // Optional: dynamically change width for desktop
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 768) {
      const heading = document.querySelector('.heading-text');
      const desc = document.querySelector('.description-text');

      if (heading) {
        heading.style.maxWidth = '{{ section.settings.heading_width_desktop }}px';
      }

      if (desc) {
        desc.style.maxWidth = '{{ section.settings.description_width_desktop }}px';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["right-image-with-text"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 768) {
      const heading = document.querySelector('.right-heading-text');
      const desc = document.querySelector('.right-description-text');

      if (heading) {
        heading.style.maxWidth = '{{ section.settings.heading_width_desktop }}px';
      }

      if (desc) {
        desc.style.maxWidth = '{{ section.settings.description_width_desktop }}px';
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
